module.exports = __webpack_public_path__ + "img/yamamoto.28cd5bf2.jpg";